/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
/* eslint no-unused-expressions: ["error", { "allowTernary": true }] */

import React, { useState, useEffect, useMemo, memo, useCallback, useRef, useReducer } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import moment from 'moment-timezone';
import classNames from 'classnames';
import filterIcon from '../../assets/images/filters.svg';
import filterArrow from '../../assets/images/filter-arrow.svg';
import plusIcon from '../../assets/images/plus-icon.svg';

import LoadingSpinner from '../../components/spinner/LoadingSpinner';
import { user } from '../../redux/user';
import {
	globalOverviewState,
	savePeriodIndex,
	saveSelectedFacilities,
	useShiftsQuery,
	useReopenShiftMutation,
	useShiftStructuresQuery,
	saveFilters,
	useCancelSlotMutation,
	useRecurringOpenSlotsMutation,
	useRouteSlotMutation,
	resetApiState,
	useFacilityFloatSlotMutation,
	useMarkSlotAsCallBackMutation
} from '../../redux/globalOverview';
import LeftSidebar from './LeftSidebar';
import calendarIcon from '../../assets/images/calendar.svg';
import arrowRight from '../../assets/images/arrow-right-black.svg';
import arrowLeft from '../../assets/images/arrow-left-black.svg';
import SingleActionModal from '../../components/modals/SingleActionModal';
import ReopenShiftModal from './ReopenShiftModal';
import { SLOT_ACTIONS } from './GlobalOverviewSlot';
import SLOT_STATUSES from '../../constants/slotStatuses';
import utils from '../../utils/utils';
import { showNotification } from '../../redux/notification';
import FilterUtils from '../../utils/FilterUtils';
import DateUtils from '../../utils/DateUtils';
import NoMatchingShifts from './NoMatchingShifts';

import { GLOBAL_OVERVIEW_SHIFT_ROUTES, GLOBAL_OVERVIEW_SHIFT_STATUS, SHIFT_TYPES } from '../../constants/ShiftStatus';
import { GLOBAL_CALENDAR_SHIFT_TYPES, PERMISSION } from '../../constants';
import SelectFacilityRequestShiftsModal from '../../components/modals/SelectFacilityRequestShiftsModal/SelectFacilityRequestShiftsModal';
import CancelSlotModal from './CancelSlotModal';
import AssignCaregiverModal from '../../components/modals/CaregiverShiftActionModals/AssignCaregiver/AssignCaregiverModal';
import GlobalOverviewFilters from './GlobalOverviewFilters';
import GlobalOverviewDay from './GlobalOverviewDay';
import ConfirmModal from '../../components/modals/BaseModal/ConfirmModal';
import { ReactComponent as WarningIcon } from '../../assets/images/warning-triangle.svg';
import { ReactComponent as RefreshIcon } from '../../assets/images/refresh-purple.svg';
import Tooltip from '../../components/Tooltip/Tooltip';
import RouteSlotModal from '../../components/modals/RouteSlotModal/RouteSlotModal';
import ShiftTypeBadge from '../shifts/ShiftTypeBadge';
import UnitAssignment from '../shifts/UnitAssignment/UnitAssignment';
import { UNIT_ASSIGNMENT_MODALS } from '../../constants/UnitAssignment';
import FacilityFloatModal from '../../components/modals/FacilityFloatModal/FacilityFloatModal';
import MarkAsCallbackModal from '../../components/modals/MarkAsCallbackModal/MarkAsCallbackModal';

import './GlobalOverviewScreen.scss';

const _periodStart = (_periodIndex) => DateUtils.getDateByOffset(_periodIndex, 0);
const _periodEnd = (_periodIndex) => DateUtils.getDateByOffset(_periodIndex, 6);

const getSlotGroups = (
	shift,
	_slots,
	caregiverFilter,
	type,
	selectedShiftRoutes,
	_selectedStatuses,
	unitsOptions,
	_selectedUnits,
	_selectedFeatures
) => {
	const areAllShiftRoutesSelected =
		Object.keys(selectedShiftRoutes).length === Object.keys(GLOBAL_OVERVIEW_SHIFT_ROUTES).length;
	const shouldFilterRoute = type === GLOBAL_CALENDAR_SHIFT_TYPES.ALL && !areAllShiftRoutesSelected;
	const areAllUnitsSelected = Object.keys(_selectedUnits).length === Object.keys(unitsOptions).length;

	return _slots.reduce(
		(acc, curr) => {
			if (caregiverFilter) {
				if (type !== GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND && type !== GLOBAL_CALENDAR_SHIFT_TYPES.ALL) {
					if (curr.caregiver_id !== parseInt(caregiverFilter.caregiver_id, 10)) {
						return acc;
					}
				} else if (!FilterUtils.matchesNameOnDemandFilter(curr.caregiver_name, caregiverFilter)) {
					return acc;
				}
			}

			if (shouldFilterRoute && !FilterUtils.matchShiftRoute(shift, curr, selectedShiftRoutes)) {
				return acc;
			}

			if (
				unitsOptions.length &&
				((!areAllUnitsSelected && curr.unit_name && !_selectedUnits[curr.unit_name]) ||
					(!curr.unit_name && !_selectedUnits.Unassigned))
			) {
				return acc;
			}

			if (!FilterUtils.matchShiftFeature(shift, curr, _selectedFeatures)) {
				return acc;
			}

			// eslint-disable-next-line no-param-reassign
			shift = {
				...shift,
				formatted_start_time: moment.tz(shift.start_time, shift.facility_timezone).format('LT'),
				formatted_end_time: moment.tz(shift.end_time, shift.facility_timezone).format('LT')
			};

			if (curr.slot_status === SLOT_STATUSES.FACILITY_CANCELLED) {
				acc.cancelled.push({ shift, slot: curr });
			} else if (curr.caregiver_id) {
				if (
					_selectedStatuses.Filled ||
					(_selectedStatuses.Confirmed && curr.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT)
				) {
					acc.filled.push({ shift, slot: curr });
				}
			} else if (
				_selectedStatuses.Open ||
				(_selectedStatuses.Confirmed && curr.slot_status === SLOT_STATUSES.CONFIRMED_SHIFT)
			) {
				curr.is_hybrid ? acc.unfilled.unshift({ shift, slot: curr }) : acc.unfilled.push({ shift, slot: curr });
			}

			return acc;
		},
		{ filled: [], unfilled: [], cancelled: [] }
	);
};

const getShiftResourceType = (shift) => {
	if (!shift.shift_specialty) {
		return shift.shift_resource_type;
	}

	return `${shift.shift_resource_type} - ${shift.shift_specialty}`;
};

const RequestButton = ({
	flexFacilities,
	facilities,
	setShowRequestShiftsFlexModal,
	setShowRequestShiftsOnDemandModal
}) => {
	const isDisabled = facilities.length === 0;
	const handleClick = () => {
		if (flexFacilities.length > 0) {
			setShowRequestShiftsFlexModal(true);
		} else {
			setShowRequestShiftsOnDemandModal(true);
		}
	};

	const button = (
		<button
			disabled={isDisabled}
			onClick={handleClick}
			type="button"
			className={classNames('request-btn', { disabled: isDisabled })}
		>
			<img src={plusIcon} alt="Request Shifts" className="request-icon" />
			Request Shifts
		</button>
	);

	return isDisabled ? (
		<Tooltip placement="left" label="You do not have permission to request shifts">
			{button}
		</Tooltip>
	) : (
		button
	);
};

function activeOptionsReducer(state, action) {
	if (action.type === 'UPDATE') {
		const { value } = action;
		return { ...state, ...value };
	}
	return state;
}

const GlobalOverviewScreen = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const userData = useSelector(user, shallowEqual) || {};
	const persistedOverviewState = useSelector(globalOverviewState, shallowEqual) || {};
	const [loading, setLoading] = useState(true);
	const [availableFacilities, setAvailableFacilities] = useState([]);
	const [selectedFacilities, setSelectedFacilities] = useState(persistedOverviewState.selectedFacilities);
	const [periodIndex, setPeriodIndex] = useState(persistedOverviewState.periodIndex);
	const [periodStart, setPeriodStart] = useState(_periodStart(periodIndex));
	const [periodEnd, setPeriodEnd] = useState(_periodEnd(periodIndex));
	const [showRequestShiftsFlexModal, setShowRequestShiftsFlexModal] = useState(false);
	const [showRequestShiftsHybridModal, setShowRequestShiftsHybridModal] = useState(false);
	const [showRequestOnCallShiftsModal, setShowRequestOnCallShiftsModal] = useState(false);

	const [showRequestShiftsOnDemandModal, setShowRequestShiftsOnDemandModal] = useState(false);
	const shiftsScroller = useRef(null);

	const [matchingShifts, setMatchingShifts] = useState({
		haveShifts: true,
		reason: null
	});

	const [shiftsWeek, setShiftsWeek] = useState(null);
	const [showRefreshModal, setShowRefreshModal] = useState(false);
	const [shiftToReopen, setShiftToReopen] = useState(null);
	const [shiftToAssign, setShiftToAssign] = useState(null);
	const [slotToUpdateUnit, setSlotToUpdateUnit] = useState({});
	const [slotToFacilityFloat, setSlotToFacilityFloat] = useState({});
	const [slotToMarkAsCallback, setSlotToMarkAsCallback] = useState({});
	const [showReopenModal, setShowReopenModal] = useState(false);

	const [slotToCancel, setSlotToCancel] = useState(null);
	const [slotToRoute, setSlotToRoute] = useState(null);
	const [showCancelModal, setShowCancelModal] = useState(false);
	const [showRouteSlotModal, setShowRouteSlotModal] = useState(false);
	const [showUpdateUnitModal, setShowUpdateUnitModal] = useState(false);
	const [showFacilityFloatModal, setShowFacilityFloatModal] = useState(false);
	const [showMarkAsCallbackModal, setShowMarkAsCallbackModal] = useState(false);

	const [showConfirmContractCancelModal, setShowConfirmContractCancelModal] = useState(false);

	const globalScheduleType = useMemo(() => {
		if (userData.flexGlobalOverviewEnabled && userData.onDemandGlobalOverviewEnabled) {
			return GLOBAL_CALENDAR_SHIFT_TYPES.ALL;
		}

		return userData.flexGlobalOverviewEnabled
			? GLOBAL_CALENDAR_SHIFT_TYPES.FLEX
			: GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND;
	}, [userData]);

	const filterFeaturesOptions = useMemo(() => {
		return globalScheduleType === GLOBAL_CALENDAR_SHIFT_TYPES.FLEX
			? FilterUtils.DEFAULT_FLEX_FEATURE_OPTIONS
			: FilterUtils.DEFAULT_FEATURE_OPTIONS;
	}, [globalScheduleType]);

	const [activeOptions, activeOptionsDispatch] = useReducer(activeOptionsReducer, {
		resourceTypes: [],
		statuses: persistedOverviewState.globalFilters.statuses,
		shiftRoutes: persistedOverviewState.globalFilters.shiftRoutes,
		units: [],
		features:
			persistedOverviewState.globalFilters.features.length > 0
				? persistedOverviewState.globalFilters.features
				: filterFeaturesOptions
	});
	const [showAssignCaregiverModal, setShowAssignCaregiverModal] = useState(false);

	const { data: globalShifts, refetch: reloadShifts, isFetching, error } = useShiftsQuery(
		{ start: periodStart.format('YYYY-MM-DD'), end: periodEnd.format('YYYY-MM-DD'), type: globalScheduleType },
		{ refetchOnMountOrArgChange: true }
	);

	const unitsByFacility = useMemo(
		() =>
			availableFacilities.reduce((acc, facility) => {
				acc[facility.id] = facility.units.map((unit) => ({ ...unit, id: Number(unit.id) }));
				return acc;
			}, {}),
		[availableFacilities]
	);

	const { data: globalShiftStructures } = useShiftStructuresQuery({ type: globalScheduleType });
	const noOrientationStructures = useMemo(
		() => globalShiftStructures?.filter((shiftStructure) => !shiftStructure.is_orientation),
		[globalShiftStructures]
	);
	const onCallShiftStructures = useMemo(
		() => noOrientationStructures?.filter((shiftStructure) => !!shiftStructure.allow_on_call),
		[noOrientationStructures]
	);

	const selectedStatuses = useMemo(
		() =>
			Object.entries(activeOptions.statuses).reduce(
				(acc, [, status]) => ({ ...acc, ...(status.checked && { [status.value]: true }) }),
				{}
			),
		[activeOptions.statuses]
	);

	const selectedResourceTypes = useMemo(
		() =>
			activeOptions.resourceTypes.reduce((acc, item) => ({ ...acc, ...(item.checked && { [item.value]: true }) }), {}),
		[activeOptions.resourceTypes]
	);

	const selectedShiftRoutes = useMemo(
		() =>
			activeOptions.shiftRoutes.reduce((acc, item) => ({ ...acc, ...(item.checked && { [item.value]: true }) }), {}),
		[activeOptions.shiftRoutes]
	);
	const selectedUnits = useMemo(
		() => activeOptions.units.reduce((acc, item) => ({ ...acc, ...(item.checked && { [item.value]: true }) }), {}),
		[activeOptions.units]
	);
	const selectedFeatures = useMemo(
		() => activeOptions.features.reduce((acc, item) => ({ ...acc, ...(item.checked && { [item.value]: true }) }), {}),
		[activeOptions.features]
	);

	const [reopenShift] = useReopenShiftMutation();
	const [routeSlot] = useRouteSlotMutation();
	const [cancelSlot] = useCancelSlotMutation();
	const [getRecurringShiftOpenSlots] = useRecurringOpenSlotsMutation();
	const [facilityFloatSlot] = useFacilityFloatSlotMutation();
	const [markSlotAsCallBack] = useMarkSlotAsCallBackMutation();

	const [selectedCaregiverFilter, setSelectedCaregiverFilter] = useState(
		persistedOverviewState.globalFilters.selectedCaregiverFilter
	);
	const [expandFilters, setExpandFilters] = useState(true);

	const areAllFacilitiesSelected = selectedFacilities.length === availableFacilities.length;

	useEffect(() => {
		if (error) {
			setLoading(false);
		}
	}, [error]);

	useEffect(() => {
		if (globalShiftStructures?.length && globalShiftStructures.length !== activeOptions?.resourceTypes?.length) {
			activeOptionsDispatch({
				type: 'UPDATE',
				value: {
					resourceTypes:
						persistedOverviewState.globalFilters.resourceTypes.length > 0
							? persistedOverviewState.globalFilters.resourceTypes
							: FilterUtils.convertResourceTypesToOptions(globalShiftStructures)
				}
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [globalShiftStructures]);

	const selectedFacilityIds = useMemo(
		() =>
			selectedFacilities
				? selectedFacilities.reduce((acc, item) => ({ ...acc, [item.id]: true }), {})
				: persistedOverviewState.selectedFacilities.reduce((acc, item) => ({ ...acc, [item.id]: true }), {}),
		[selectedFacilities, persistedOverviewState.selectedFacilities]
	);

	useEffect(() => {
		const hasPreviouslySelectedUnits =
			persistedOverviewState.globalFilters.units.length &&
			persistedOverviewState.globalFilters.units.find((u) => !u.checked);
		activeOptionsDispatch({
			type: 'UPDATE',
			value: {
				units: FilterUtils.convertFacilityUnitsToUnitOptions(selectedFacilities, selectedFacilityIds).map((unit) => ({
					...unit,
					checked: hasPreviouslySelectedUnits
						? !!persistedOverviewState.globalFilters.units.find((u) => u.id === unit.id)?.checked
						: true
				}))
			}
		});
	}, [selectedFacilityIds]);

	useEffect(() => {
		if (userData.facilitiesEnabled) {
			const sortByAlpha = (a, b) => a.label.localeCompare(b.label);
			const enabledFacilities = userData.facilitiesEnabled
				.filter(
					(fc) =>
						(fc.allow_flex_shifts && !!fc.is_flex_global_calendar_enabled) ||
						(fc.allow_on_demand_shifts && !!fc.is_on_demand_global_calendar_enabled)
				)
				.sort(sortByAlpha);

			setAvailableFacilities(enabledFacilities);
			if (!persistedOverviewState.selectedFacilities.length) {
				setSelectedFacilities(enabledFacilities.map((f) => ({ ...f, checked: true })));
			}
		}
	}, [userData.facilitiesEnabled]);

	const initShiftsWeek = (index) =>
		[...Array(DateUtils.DAYS_IN_WEEK).keys()].reduce(
			(acc, day) => ({
				...acc,
				[DateUtils.getFormattedDateByOffset(index, day)]: {
					filledSlotsCount: 0,
					unfilledSlotsCount: 0,
					cancelledSlotsCount: 0,
					filteredShiftsCount: 0,
					shifts: {}
				}
			}),
			{}
		);

	const showFilled = selectedStatuses[GLOBAL_OVERVIEW_SHIFT_STATUS.FILLED.name];
	const showOpen = selectedStatuses[GLOBAL_OVERVIEW_SHIFT_STATUS.OPEN.name];
	const showConfirmed = selectedStatuses[GLOBAL_OVERVIEW_SHIFT_STATUS.CONFIRMED.name];
	const showCancelled = selectedStatuses[GLOBAL_OVERVIEW_SHIFT_STATUS.CANCELLED.name];

	const showOptions = useMemo(() => ({ showFilled, showOpen, showConfirmed, showCancelled }), [
		showFilled,
		showOpen,
		showConfirmed,
		showCancelled
	]);
	/**
	 *
	 * Helper function that groups shifts with the same shift structure
	 * it does so under an identifier with the {shiftStructure}-{shiftDay} format
	 *
	 */
	const groupSimilarShifts = (shifts) => {
		return shifts.reduce((acc, shift) => {
			const startDate = moment.tz(shift.start_time, shift.facility_timezone);
			const endDate = moment.tz(shift.end_time, shift.facility_timezone);
			const identifier = `${shift.shift_structure_id}-${startDate.format('ddd M/D')}${
				shift.is_on_call ? '-onCall' : ''
			}`;
			const isUpcomingShift = endDate.isSameOrAfter(moment.tz(shift.facility_timezone));
			const { filled, unfilled, cancelled } = getSlotGroups(
				shift,
				shift.slots,
				selectedCaregiverFilter,
				globalScheduleType,
				selectedShiftRoutes,
				selectedStatuses,
				activeOptions.units,
				selectedUnits,
				selectedFeatures
			);

			// Initialize the object if it does not exist
			acc[identifier] = acc[identifier] ?? {
				shift_types: new Set(),
				identifier,
				facility_id: shift.facility_id,
				is_on_call: shift.is_on_call,
				facility_name: shift.facility_name,
				shift_resource_type: shift.shift_resource_type,
				shift_specialty: shift.shift_specialty,
				is_orientation: shift.is_orientation,
				formatted_start_time: startDate.format('LT'),
				formatted_end_time: endDate.format('LT'),
				isUpcomingShift,
				rank: shift.rank,
				filledSlotsCount: 0,
				unfilledSlotsCount: 0,
				cancelledSlotsCount: 0,
				filledSlots: [],
				unfilledSlots: [],
				cancelledSlots: [],
				hasUnitsEnabled: availableFacilities.find((fac) => Number(fac.id) === Number(shift.facility_id))
					?.portal_units_enabled
			};

			// After we are sure we have the shift structure initialized we can increase the counters
			acc[identifier] = {
				...acc[identifier],
				...((showFilled || showConfirmed) && { filledSlotsCount: acc[identifier].filledSlotsCount + filled.length }),
				...((showOpen || showConfirmed) && {
					unfilledSlotsCount: acc[identifier].unfilledSlotsCount + unfilled.length
				}),
				...(showCancelled && { cancelledSlotsCount: acc[identifier].cancelledSlotsCount + cancelled.length })
			};
			// After we have increased the counters we push to the arrays
			acc[identifier].shift_types.add(shift.shift_type);
			acc[identifier].filledSlots.push(...filled);
			acc[identifier].unfilledSlots.push(...unfilled);
			acc[identifier].cancelledSlots.push(...cancelled);

			if (shift.shift_type === GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND && !!shift.has_hybrid_slots) {
				acc[identifier].shift_types.add(GLOBAL_CALENDAR_SHIFT_TYPES.FLEX);
			}
			return acc;
		}, {});
	};

	/**
	 *
	 * This function groups shifts by day and after that it groups them by shift structure
	 * This way flex and on demand shifts that are on the same day with the same shift structure appear as one
	 * Example return
	 * {
	 * 		'Fri 4/25': { // Day grouping
	 * 			filledSlotsCount: 0,
	 *			unfilledSlotsCount: 0,
	 *			cancelledSlotsCount: 0,
	 *			filteredShiftsCount: 0,
	 *			shifts: {
	 *				'35': { // Shift structure grouping
	 *					shift_types: ['FLEX],
	 *					shift_resource_type: CNA,
	 *					facility_name: Test Facility,
	 *					is_orientation: false,
	 *					formatted_start_time: 7:00 AM,
	 *					formatted_end_time: 8:00AM,
	 *					isUpcomingShift: true,
	 *					filledSlotsCount: 0,
	 *					unfilledSlotsCount: 0,
	 *					filledSlots: [{shift, slot}],
	 *					unfilledSlots: [{shift, slot}],
	 *					cancelledSlots: [{shift, slot}]
	 *					shift_specialty: null,
	 * 				}
	 *			}
	 *
	 * 		}
	 * }
	 *
	 */
	const groupShifts = (shifts) => {
		const similarShifts = groupSimilarShifts(shifts);
		const areAllResourceTypesSelected =
			Object.keys(selectedResourceTypes).length === Object.keys(activeOptions.resourceTypes).length;

		const days = Object.entries(similarShifts).reduce((acc, [key, similarShift]) => {
			// Destructure the key to group by day
			const [shiftStructure, shiftDay, onCall] = key.split('-');
			if (
				selectedFacilityIds[similarShift.facility_id] &&
				(areAllResourceTypesSelected || selectedResourceTypes[getShiftResourceType(similarShift)])
			) {
				const filteredCount =
					similarShift.filledSlotsCount + similarShift.unfilledSlotsCount + similarShift.cancelledSlotsCount;

				// We need to only add a shift if it has not been filtered because virtuoso can't render empty items
				if (filteredCount) {
					acc[shiftDay] = {
						...acc[shiftDay],
						filledSlotsCount: acc[shiftDay].filledSlotsCount + similarShift.filledSlotsCount,
						unfilledSlotsCount: acc[shiftDay].unfilledSlotsCount + similarShift.unfilledSlotsCount,
						cancelledSlotsCount: acc[shiftDay].cancelledSlotsCount + similarShift.cancelledSlotsCount,
						filteredShiftsCount: acc[shiftDay].filteredShiftsCount + filteredCount
					};
					const sortingIdentifier = `${similarShift.formatted_start_time}-${similarShift.facility_name}-${
						similarShift.rank
					}-${shiftStructure}${onCall ? '-on-call' : ''}`;
					acc[shiftDay].shifts[sortingIdentifier] = { ...acc[shiftDay].shifts[sortingIdentifier], ...similarShift };
				}

				return acc;
			}
			return acc;
		}, initShiftsWeek(periodIndex)); // We initialize the object for 7 days of the week

		setShiftsWeek(days);
		setLoading(false);
	};

	useEffect(() => {
		if (selectedFacilities.length && globalShifts) {
			groupShifts(globalShifts);
		}
	}, [selectedCaregiverFilter, globalScheduleType, globalShifts, selectedFacilities, activeOptions]);

	const onFacilityFilter = (_selectedFacilities) => {
		setSelectedFacilities(_selectedFacilities);
		setLoading(true);
		dispatch(saveSelectedFacilities(_selectedFacilities));
	};

	const onSelectToday = () => {
		if (periodIndex !== 0) {
			setPeriodIndex(0);
			setPeriodStart(_periodStart(0));
			setPeriodEnd(_periodEnd(0));
			setLoading(true);
			dispatch(savePeriodIndex(0));
		}
	};

	const onPreviousPeriod = () => {
		if (periodIndex > -26) {
			/* 6 months in the past */
			setPeriodIndex(periodIndex - 1);
			setPeriodStart(_periodStart(periodIndex - 1));
			setPeriodEnd(_periodEnd(periodIndex - 1));
			setLoading(true);
			dispatch(savePeriodIndex(periodIndex - 1));
		}
	};
	const onNextPeriod = () => {
		if (periodIndex < 104) {
			/* 2 years in the future */
			setPeriodIndex(periodIndex + 1);
			setPeriodStart(_periodStart(periodIndex + 1));
			setPeriodEnd(_periodEnd(periodIndex + 1));
			setLoading(true);
			dispatch(savePeriodIndex(periodIndex + 1));
		}
	};

	const onReopenShift = async () => {
		try {
			await reopenShift({ slot: shiftToReopen.slot }).unwrap();
			dispatch(showNotification('success', 'Shift has been successfully reopened.'));
		} catch (reopenError) {
			const fallbackMessage = `There was an error reopening the shift.`;
			dispatch(showNotification('error', utils.parseRTKQueryValidationError(reopenError, fallbackMessage)));
		} finally {
			setShowReopenModal(false);
		}
	};

	const onRouteSlot = async (shift) => {
		try {
			const { slot } = shift;
			await routeSlot({ slot }).unwrap();
			dispatch(showNotification('success', 'Shift has been successfully routed.'));
		} catch (reopenError) {
			const fallbackMessage = `There was an error routing the shift.`;
			dispatch(showNotification('error', utils.parseRTKQueryValidationError(reopenError, fallbackMessage)));
		} finally {
			setShowRouteSlotModal(false);
		}
	};

	const onFacilityFloatSlot = async (targetFacilityId, caregiverId, structureId, unitId) => {
		try {
			const { slot } = slotToFacilityFloat;
			await facilityFloatSlot({ slot, targetFacilityId, caregiverId, structureId, unitId }).unwrap();
			dispatch(showNotification('success', 'Shift has been successfully floated.'));
			setShowFacilityFloatModal(false);
		} catch (floatError) {
			if (!Array.isArray(floatError?.data?.errors) || floatError.data.errors[0]?.field === 'end_time') {
				const fallbackMessage = `There was an error floating the shift.`;
				setShowFacilityFloatModal(false);
				dispatch(showNotification('error', utils.parseRTKQueryValidationError(floatError, fallbackMessage)));
				return {};
			}
			return floatError;
		}
		return {};
	};

	const onMarkSlotAsCallBack = async () => {
		try {
			const { shift, slot } = slotToMarkAsCallback;
			await markSlotAsCallBack({ slotId: slot.slot_id, facilityId: shift.facility_id }).unwrap();
			dispatch(showNotification('success', 'Shift has been successfully marked as callback.'));
		} catch (markAsCallbackError) {
			const fallbackMessage = `There was an error routing the shift.`;
			dispatch(showNotification('error', utils.parseRTKQueryValidationError(markAsCallbackError, fallbackMessage)));
		} finally {
			setShowMarkAsCallbackModal(false);
		}
	};

	const getOpenSlotForRecurring = async (shift) => {
		try {
			setLoading(true);
			const [openSlot] = await getRecurringShiftOpenSlots({
				isRecurring: true,
				shiftId: shift.shift_id,
				shiftDate: moment.tz(shift.start_time, shift.facility_timezone).format('YYYY-MM-DD')
			}).unwrap();
			return openSlot;
		} catch (openSlotError) {
			const errorMessage =
				openSlotError?.data?.errors[0]?.field === 'shiftId'
					? 'The shift you selected has been updated to reflect the latest changes.'
					: 'There was an error going to the shift.';
			dispatch(showNotification('error', errorMessage));
			return null;
		} finally {
			setLoading(false);
		}
	};

	const handleSlotAction = useCallback(async (action, shift, slot, shifts) => {
		switch (action) {
			case SLOT_ACTIONS.GO_TO_SHIFT:
				if (shift.is_recurring) {
					const openSlot = await getOpenSlotForRecurring(shift);
					if (openSlot) {
						history.push(
							`/private/shifts?slotId=${openSlot.slot_id}&facilityId=${shift.facility_id}&shiftType=${shift.shift_type}&fromGlobalOverview=true`
						);
					}
				} else {
					const shiftType = slot.is_hybrid ? SHIFT_TYPES.HYBRID : shift.shift_type;
					history.push(
						`/private/shifts?slotId=${slot.slot_id}&facilityId=${shift.facility_id}&shiftType=${shiftType}&fromGlobalOverview=true`
					);
				}
				break;
			case SLOT_ACTIONS.REOPEN_SHIFT:
				setShiftToReopen({ shift, slot });
				setShowReopenModal(true);
				break;
			case SLOT_ACTIONS.CANCEL_SLOT:
				setSlotToCancel({ shift, slot });
				if (slot.contract_id) {
					setShowConfirmContractCancelModal(true);
				} else {
					setShowCancelModal(true);
				}
				break;
			case SLOT_ACTIONS.ASSIGN_SHIFT:
				setShiftToAssign({
					...shift,
					...slot,
					id: shift.shift_id,
					resourceType: getShiftResourceType(shift),
					shiftsForAllDay: shifts
				});
				setShowAssignCaregiverModal(true);
				break;
			case SLOT_ACTIONS.ROUTE_SLOT:
				setSlotToRoute({ shift, slot });
				setShowRouteSlotModal(true);
				break;
			case SLOT_ACTIONS.UPDATE_UNIT:
				setSlotToUpdateUnit({
					...slot,
					facility_id: shift.facility_id,
					is_flex: shift.shift_type === GLOBAL_CALENDAR_SHIFT_TYPES.FLEX,
					resource_type: shift.shift_resource_type + (shift.shift_specialty ? ` - ${shift.shift_specialty}` : ''),
					isRecurring: shift.is_recurring ?? false,
					shift_id: shift.shift_id,
					facility_timezone: shift.facility_timezone,
					facility_name: shift.facility_name
				});
				setShowUpdateUnitModal(UNIT_ASSIGNMENT_MODALS.edit);
				break;
			case SLOT_ACTIONS.FACILITY_FLOAT:
				setSlotToFacilityFloat({ shift, slot });
				setShowFacilityFloatModal(true);
				break;
			case SLOT_ACTIONS.MARK_AS_CALLBACK:
				setShowMarkAsCallbackModal(true);
				setSlotToMarkAsCallback({ shift, slot });
				break;
			default:
				break;
		}
	}, []);

	const removeSelectedCaregiver = () => {
		if (selectedCaregiverFilter) {
			setSelectedCaregiverFilter(null);
			groupShifts(globalShifts);
			dispatch(saveFilters({ ...persistedOverviewState.globalFilters, selectedCaregiverFilter: null }));
		}
	};

	const handleExpandFilters = () => setExpandFilters(!expandFilters);

	const filterCount = useMemo(() => {
		let count = 0;
		if (Object.keys(selectedStatuses).length < Object.keys(GLOBAL_OVERVIEW_SHIFT_STATUS).length) {
			count += 1;
		}
		if (Object.keys(selectedResourceTypes).length < Object.keys(activeOptions.resourceTypes).length) {
			count += 1;
		}
		if (Object.keys(selectedShiftRoutes).length < Object.keys(activeOptions.shiftRoutes).length) {
			count += 1;
		}
		if (selectedCaregiverFilter) {
			count += 1;
		}
		if (Object.keys(selectedUnits).length < Object.keys(activeOptions.units).length) {
			count += 1;
		}
		if (Object.keys(selectedFeatures).length < Object.keys(filterFeaturesOptions).length) {
			count += 1;
		}
		return count;
	}, [
		selectedStatuses,
		activeOptions,
		selectedCaregiverFilter,
		selectedUnits,
		selectedFeatures,
		selectedShiftRoutes,
		selectedResourceTypes
	]);

	const handleClearAll = () => {
		const convertedStatuses = FilterUtils.convertGlobalOverviewShiftStatusToOptions(GLOBAL_OVERVIEW_SHIFT_STATUS).map(
			(status) => ({
				...status,
				checked: true
			})
		);

		const checkedResourceTypes = FilterUtils.convertResourceTypesToOptions(globalShiftStructures).map(
			(resourceType) => ({
				...resourceType,
				checked: true
			})
		);

		const checkedUnits = FilterUtils.convertFacilityUnitsToUnitOptions(selectedFacilities, selectedFacilityIds).map(
			(unit) => ({
				...unit,
				checked: true
			})
		);

		const convertedShiftRoutes = FilterUtils.convertGlobalOverviewShiftStatusToOptions(
			GLOBAL_OVERVIEW_SHIFT_ROUTES
		).map((status) => ({
			...status,
			checked: true
		}));

		activeOptionsDispatch({
			type: 'UPDATE',
			value: {
				resourceTypes: checkedResourceTypes,
				statuses: convertedStatuses,
				shiftRoutes: convertedShiftRoutes,
				units: checkedUnits,
				features: filterFeaturesOptions
			}
		});
		setSelectedCaregiverFilter(null);
		dispatch(
			saveFilters({
				resourceTypes: checkedResourceTypes,
				shiftRoutes: convertedShiftRoutes,
				statuses: convertedStatuses,
				selectedCaregiverFilter: null,
				units: checkedUnits,
				features: filterFeaturesOptions
			})
		);
	};

	const NOT_MATCHING_SHIFTS_MAP = useMemo(
		() => ({
			NO_SHIFTS: {
				labels: {
					title: 'None of your facilities have shifts for this week.',
					subtitle: ''
				},
				labelBtn: '',
				actionBtn: () => {}
			},
			NO_SHIFTS_WITH_FILTERS: {
				labels: {
					title: 'There are currently no shifts to display this week.',
					subtitle: 'Clear or update your filters to see more shifts.'
				},
				labelBtn: 'Clear Filters',
				actionBtn: handleClearAll
			},
			NO_SHIFT_FACILITIES_SELECTED: {
				labels: {
					title: 'There are currently no shifts at your selected facilities.',
					subtitle: 'Reset or update your facilities filter to see more shifts.'
				},
				labelBtn: 'Reset Facilities',
				actionBtn: () => {
					const allFaciltiesSelected = availableFacilities.map((f) => ({ ...f, checked: true }));
					setSelectedFacilities(allFaciltiesSelected);
					setAvailableFacilities(allFaciltiesSelected);
					dispatch(saveSelectedFacilities(allFaciltiesSelected));
				}
			}
		}),
		[availableFacilities, handleClearAll, availableFacilities]
	);

	useEffect(() => {
		let reason = null;
		let haveShifts = true;
		if (shiftsWeek) {
			const totalWeekShifts = Object.entries(shiftsWeek)?.reduce((acc, [, week]) => acc + week.filteredShiftsCount, 0);

			if (!areAllFacilitiesSelected && totalWeekShifts === 0 && globalShifts.length > 0) {
				reason = NOT_MATCHING_SHIFTS_MAP.NO_SHIFT_FACILITIES_SELECTED;
			} else if (filterCount > 0 && totalWeekShifts === 0 && globalShifts.length > 0) {
				reason = NOT_MATCHING_SHIFTS_MAP.NO_SHIFTS_WITH_FILTERS;
			} else if (totalWeekShifts === 0) {
				reason = NOT_MATCHING_SHIFTS_MAP.NO_SHIFTS;
			}

			haveShifts = !reason;
		}

		setMatchingShifts({
			haveShifts,
			reason
		});
	}, [shiftsWeek, selectedFacilities, availableFacilities]);

	const handleCaregiverFilterSelection = (caregiver) => {
		dispatch(saveFilters({ ...persistedOverviewState.globalFilters, selectedCaregiverFilter: caregiver }));
		setSelectedCaregiverFilter(caregiver);
	};

	const handleMultiSelectFiltersApply = (key, options) => {
		setLoading(true);
		activeOptionsDispatch({
			type: 'UPDATE',
			value: { [key]: options }
		});

		const updatedFilters = {
			...persistedOverviewState.globalFilters,
			[key]: options.map((option) => ({ ...option, checked: option.checked }))
		};
		dispatch(saveFilters(updatedFilters));
	};

	const {
		facilities,
		flexFacilities,
		onDemandFacilities,
		hybridFacilities,
		onCallFacilities,
		flexEnabled,
		onDemandEnabled,
		hybridEnabled
	} = useMemo(() => {
		const { permissionsByFacility } = userData;

		const allFacilities = [];
		const flexOnlyFacilities = [];
		const onlyOnDemandFacilities = [];
		const allHybridFacilities = [];
		const _onCallFacilities = [];

		let _flexEnabled = false;
		let _onDemandEnabled = false;
		let _hybridEnabled = false;

		availableFacilities.forEach((facility) => {
			const canFlex = !!facility.is_flex_global_calendar_enabled && !!facility.allow_flex_shifts;
			const canOnDemand = !!facility.is_on_demand_global_calendar_enabled && !!facility.allow_on_demand_shifts;
			const canHybrid = canFlex && canOnDemand && !!facility.enable_hybrid_shifts;
			const canOnCall = canOnDemand && !!facility.allow_on_call;

			if (canFlex) _flexEnabled = true;
			if (canOnDemand) _onDemandEnabled = true;
			if (canHybrid) _hybridEnabled = true;

			const isFlex = canFlex && !!permissionsByFacility[facility.id]?.includes(PERMISSION.FLEX_ADD_EDIT_SHIFT);
			const isOnDemand = canOnDemand && !!permissionsByFacility[facility.id]?.includes(PERMISSION.EDIT);
			const isOnCall = canOnCall && !!permissionsByFacility[facility.id]?.includes(PERMISSION.ON_CALL_ADD_EDIT_SHIFT);

			if (!isFlex && !isOnDemand) return;

			const facilityInfo = {
				id: facility.id,
				label: facility.label,
				value: facility.id,
				isFlex,
				isOnDemand,
				units: facility.units,
				portal_units_enabled: facility.portal_units_enabled,
				managementCompanyId: facility.management_company_id
			};

			if (isFlex) flexOnlyFacilities.push(facilityInfo);
			if (isOnDemand) onlyOnDemandFacilities.push(facilityInfo);
			if (isFlex && isOnDemand && canHybrid) {
				allHybridFacilities.push(facilityInfo);
			}
			if (isOnCall) {
				_onCallFacilities.push(facilityInfo);
			}
			allFacilities.push(facilityInfo);
		});

		return {
			facilities: allFacilities,
			flexFacilities: flexOnlyFacilities,
			onDemandFacilities: onlyOnDemandFacilities,
			hybridFacilities: allHybridFacilities,
			onCallFacilities: _onCallFacilities,
			flexEnabled: _flexEnabled,
			onDemandEnabled: _onDemandEnabled,
			hybridEnabled: _hybridEnabled
		};
	}, [userData, availableFacilities]);

	const editFlexShiftFacilitiesByManagementCompany = useMemo(
		() =>
			flexFacilities.reduce((acc, facility) => {
				acc[facility.managementCompanyId] = acc[facility.managementCompanyId] ?? [];
				acc[facility.managementCompanyId].push(facility.id);
				return acc;
			}, {}),
		[flexFacilities]
	);

	const handleShiftCancel = async (
		cancelationReason,
		needsReplacement,
		isLateCancelation = null,
		acknowledgmentAccepted = null,
		agencyName = null,
		isNonClaimedSlot = false,
		facilityBillableCancellationHours = null,
		facilityWindowCancellationHours = null
	) => {
		const shiftType = slotToCancel.shift.shift_type;
		const payload = {
			shiftType,
			slotId: slotToCancel.shift.is_recurring ? slotToCancel.shift.shift_id : slotToCancel.slot.slot_id,
			cancelationReason,
			needsReplacement,
			extraInfo: agencyName ? { reason: agencyName } : null,
			...(shiftType === GLOBAL_CALENDAR_SHIFT_TYPES.ON_DEMAND && {
				facilityId: slotToCancel.shift.facility_id,
				isGuaranteed: !!slotToCancel.slot.is_guaranteed,
				isRecurring: !!slotToCancel.shift.is_recurring,
				shiftDate: moment.utc(slotToCancel.shift.start_time).format('YYYY-MM-DD'),
				guaranteeAcknowledge: acknowledgmentAccepted,
				lateCancelationAcknowledge: acknowledgmentAccepted,
				isLateCancelation,
				isNonClaimedSlot,
				facilityBillableCancellationHours,
				facilityWindowCancellationHours
			})
		};
		try {
			await cancelSlot(payload).unwrap();
			dispatch(showNotification('success', 'Shift cancelled successfully.'));
		} catch (cancelSlotError) {
			let errorMessage = utils.parseRTKQueryValidationError(cancelSlotError, 'Failed update shift. Please try again!');
			if (errorMessage === 'Slot has already been cancelled, please refresh the page.') {
				errorMessage =
					'The selected slot was already cancelled. The page has been refreshed to show the latest changes.';
			}

			dispatch(showNotification('error', errorMessage));
		} finally {
			setShowCancelModal(false);
		}
	};

	const refetchFeed = async () => {
		await reloadShifts({
			start: periodStart.format('YYYY-MM-DD'),
			end: periodEnd.format('YYYY-MM-DD')
		});
	};

	const handleOnAssign = (notificationType, message) => {
		dispatch(showNotification(notificationType, message));
		setShowAssignCaregiverModal(false);
		refetchFeed();
	};

	const canPostMultipleTypesOfShifts =
		(onDemandFacilities.length > 0 && flexFacilities.length > 0) ||
		(onDemandFacilities.length > 0 && onCallFacilities.length > 0);

	return (
		<>
			{showRefreshModal && (
				<SingleActionModal
					confirmModal
					title="Refresh the Page"
					actionLabel="Refresh Now"
					onAction={() => {
						setShowRefreshModal(false);
						dispatch(resetApiState());
					}}
					className="refresh-modal"
					onHide={() => setShowRefreshModal(false)}
					disableClickOutside
				>
					The shift you selected occurs in the past and cannot be displayed. Refresh now to reflect the latest changes.
				</SingleActionModal>
			)}

			<UnitAssignment
				availableUnits={unitsByFacility[slotToUpdateUnit?.facility_id] || []}
				setIsLoading={setLoading}
				setShowModal={setShowUpdateUnitModal}
				showModal={showUpdateUnitModal}
				slot={slotToUpdateUnit}
				showOnDemandShiftTypeBadges={userData.allowFlexShifts}
				onFinish={refetchFeed}
				isRecurring={slotToUpdateUnit?.isRecurring ?? false}
			/>

			{showReopenModal && (
				<ReopenShiftModal
					onCancel={() => setShowReopenModal(false)}
					setShowModal={showReopenModal}
					onConfirm={onReopenShift}
					shiftToReopen={shiftToReopen.shift}
				/>
			)}
			{showCancelModal && (
				<CancelSlotModal
					onClose={() => setShowCancelModal(false)}
					setShowModal={showCancelModal}
					onConfirm={handleShiftCancel}
					shiftToCancel={slotToCancel}
				/>
			)}
			{showRouteSlotModal && (
				<RouteSlotModal
					onClose={() => setShowRouteSlotModal(false)}
					setShowModal={showRouteSlotModal}
					onConfirm={() => onRouteSlot(slotToRoute)}
					shiftToRoute={slotToRoute}
					badge={<ShiftTypeBadge shiftType="flex" />}
				/>
			)}
			{showFacilityFloatModal && (
				<FacilityFloatModal
					onClose={() => setShowFacilityFloatModal(false)}
					onConfirm={onFacilityFloatSlot}
					shiftToFloat={slotToFacilityFloat}
				/>
			)}
			{showMarkAsCallbackModal && (
				<MarkAsCallbackModal
					onClose={() => setShowMarkAsCallbackModal(false)}
					shiftToMarkAsCallback={slotToMarkAsCallback}
					onConfirm={onMarkSlotAsCallBack}
				/>
			)}
			{showConfirmContractCancelModal && (
				<ConfirmModal
					className="confirm-contract-cancel-modal"
					onHide={() => setShowConfirmContractCancelModal(false)}
					onPrimaryAction={() => {
						setShowConfirmContractCancelModal(false);
						setShowCancelModal(true);
					}}
					onSecondaryAction={() => setShowConfirmContractCancelModal(false)}
					primaryActionLabel="Continue"
					secondaryActionLabel="Keep Shift"
					title="Please Confirm"
					titleIcon={<WarningIcon />}
				>
					This shift is part of a <span>{slotToCancel.slot.contract_non_cancelled_slots_count}-shift bundle.</span> Are
					you sure that you want to cancel the shift?
				</ConfirmModal>
			)}
			{showAssignCaregiverModal && (
				<AssignCaregiverModal
					key="assign-caregiver_modal"
					onCancel={() => {
						setShowAssignCaregiverModal(false);
					}}
					onAssign={handleOnAssign}
					shift={shiftToAssign}
					backdropClassName="invite-caregiver-backdrop"
					isGlobalCalendar
				/>
			)}

			<div className="global-overview-screen" ref={shiftsScroller}>
				<LeftSidebar
					availableFacilities={availableFacilities}
					selectedFacilities={selectedFacilities}
					onApply={onFacilityFilter}
				/>

				<div className="overview-container">
					<div className="header-container">
						<div className="heading">
							<img src={calendarIcon} alt="Overview" className="calendar-icon" />
							<span>Global Schedule</span>
						</div>
						{!canPostMultipleTypesOfShifts ? (
							<RequestButton
								flexFacilities={flexFacilities}
								facilities={facilities}
								setShowRequestShiftsFlexModal={setShowRequestShiftsFlexModal}
								setShowRequestShiftsOnDemandModal={setShowRequestShiftsOnDemandModal}
							/>
						) : (
							<Dropdown>
								<Dropdown.Toggle className="request-btn" id="dropdown-basic">
									<img src={plusIcon} alt="Request Shifts" className="request-icon" />
									Request Shifts
								</Dropdown.Toggle>
								{facilities.length > 0 && (
									<>
										<Dropdown.Menu className="request-menu">
											{onDemandFacilities.length > 0 && (
												<Dropdown.Item
													className="request-menu-item"
													onClick={() => setShowRequestShiftsOnDemandModal(true)}
												>
													On Demand
												</Dropdown.Item>
											)}
											{flexFacilities.length > 0 && (
												<Dropdown.Item
													className="request-menu-item"
													onClick={() => setShowRequestShiftsFlexModal(true)}
												>
													Internal Flex
												</Dropdown.Item>
											)}
											{hybridFacilities.length > 0 && (
												<Dropdown.Item
													className="request-menu-item "
													onClick={() => setShowRequestShiftsHybridModal(true)}
												>
													Hybrid
												</Dropdown.Item>
											)}
											{onCallFacilities.length > 0 && (
												<Dropdown.Item
													className="request-menu-item "
													onClick={() => setShowRequestOnCallShiftsModal(true)}
												>
													On Call
												</Dropdown.Item>
											)}
										</Dropdown.Menu>
									</>
								)}
							</Dropdown>
						)}
					</div>

					<div className="timeframe-selector-container">
						<button type="button" className="btn btn-light" onClick={onSelectToday}>
							Today
						</button>
						<div className="shifts-period">
							<img
								src={arrowLeft}
								alt="Previous period"
								className={classNames('shifts-period-nav', { disabled: periodIndex === -26 })}
								onClick={onPreviousPeriod}
								aria-hidden="true"
							/>
							<div className="d-flex align-items-center">
								<div className="nav-date-item d-flex justify-content-end">{periodStart.format('ddd, MMM D, YYYY')}</div>
								<span className="dates-separate">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
								<div className="nav-date-item">{periodEnd.format('ddd, MMM D, YYYY')}</div>
							</div>
							<img
								src={arrowRight}
								alt="Next period"
								className={classNames('shifts-period-nav', { disabled: periodIndex === 104 })}
								onClick={onNextPeriod}
								aria-hidden="true"
							/>
						</div>
						<button type="button" className="btn btn-light refresh-button" onClick={refetchFeed}>
							<RefreshIcon />
							<span>Refresh</span>
						</button>
						<div className="view-by-container">
							{filterCount > 0 && (
								<button type="button" onClick={handleClearAll} className="filter-btn clear">
									Clear all
								</button>
							)}
							<button
								type="button"
								onClick={handleExpandFilters}
								className={classNames('filter-container', 'filter-btn', { noFilterCount: filterCount === 0 })}
							>
								<img src={filterIcon} alt="filters" />
								<div className="filter-text">Filters</div>
								{filterCount > 0 && <div className="filter-number">{filterCount}</div>}
								<img src={filterArrow} alt="expand" className={classNames('arrow-icon', { down: !expandFilters })} />
							</button>
						</div>
					</div>
					{expandFilters && (
						<GlobalOverviewFilters
							activeOptions={activeOptions}
							selectedCaregiver={selectedCaregiverFilter}
							handleCaregiverFilterSelection={handleCaregiverFilterSelection}
							handleMultiSelectFiltersApply={handleMultiSelectFiltersApply}
							removeSelectedCaregiver={removeSelectedCaregiver}
							globalScheduleType={globalScheduleType}
							isHybridEnabled={hybridEnabled}
							isFlexEnabled={flexEnabled}
							isOnDemandEnabled={onDemandEnabled}
							areAllFacilitiesSelected={areAllFacilitiesSelected}
						/>
					)}

					<div className="week-days-container">
						{shiftsWeek &&
							[...Array(DateUtils.DAYS_IN_WEEK).keys()].map((i) => (
								<GlobalOverviewDay
									key={`global-schedule-day-${i}`}
									day={i}
									shiftsScroller={shiftsScroller.current}
									periodIndex={periodIndex}
									dayShifts={shiftsWeek[DateUtils.getFormattedDateByOffset(periodIndex, i)]}
									handleSlotAction={handleSlotAction}
									setShowRefreshModal={setShowRefreshModal}
									showOptions={showOptions}
									globalScheduleType={globalScheduleType}
									matchingShifts={matchingShifts}
									unitsByFacility={unitsByFacility}
									editFlexShiftFacilitiesByManagementCompany={editFlexShiftFacilitiesByManagementCompany}
								/>
							))}
					</div>
					{!matchingShifts.haveShifts && <NoMatchingShifts reason={matchingShifts.reason} />}
				</div>

				{(loading || isFetching) && <LoadingSpinner />}
			</div>

			{(showRequestShiftsFlexModal || showRequestShiftsOnDemandModal) && (
				<SelectFacilityRequestShiftsModal
					updateFeed={refetchFeed}
					shiftStructures={globalShiftStructures}
					setIsLoading={setLoading}
					user={userData}
					title={showRequestShiftsFlexModal ? 'Request Internal Flex Shifts' : 'Request On Demand Shifts'}
					isFlex={showRequestShiftsFlexModal}
					facilities={showRequestShiftsFlexModal ? flexFacilities : onDemandFacilities}
					onClose={
						showRequestShiftsFlexModal
							? () => setShowRequestShiftsFlexModal(false)
							: () => setShowRequestShiftsOnDemandModal(false)
					}
					isGlobalCalendar
				/>
			)}

			{showRequestShiftsHybridModal && (
				<SelectFacilityRequestShiftsModal
					updateFeed={refetchFeed}
					shiftStructures={noOrientationStructures}
					setIsLoading={setLoading}
					user={userData}
					title="Request Hybrid shifts"
					isHybrid
					facilities={hybridFacilities}
					onClose={() => setShowRequestShiftsHybridModal(false)}
					isGlobalCalendar
				/>
			)}
			{showRequestOnCallShiftsModal && (
				<SelectFacilityRequestShiftsModal
					updateFeed={refetchFeed}
					shiftStructures={onCallShiftStructures}
					setIsLoading={setLoading}
					user={userData}
					title="Request On Call shifts"
					facilities={onCallFacilities}
					onClose={() => setShowRequestOnCallShiftsModal(false)}
					isGlobalCalendar
					isOnCall
				/>
			)}
		</>
	);
};

export default memo(GlobalOverviewScreen);
